import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deleteComment",
  style: {"z-index":"1600"},
  tabindex: "-1",
  "aria-labelledby": "deleteComment",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title w-100 text-center fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "text-center my-4" }
const _hoisted_8 = { class: "modal-footer d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { POST_STORE, USER_POST_STORE, COMMUNITY_SITE_STORE } from '@/store/constants'
import { PropType } from 'vue'
import { POST_COMMUNITY_SITE_NOT_FOUND } from '@/constants/index'
import { useToast } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import communitySitePostDeleted from '@/components/toast-error/communitySitePostDeleted.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  postId: String,
  postCommentId: String,
  create_by_admin: Boolean,
  commentPublishedFlg: Boolean,
  isCSPDetail: Boolean,
  handleDeleteClick: Function as PropType<Promise<any>>,
},
  emits: ['showDeleteCommentSuccessModal'],
  setup(__props, { emit }) {

const props = __props



const route = useRoute()
const store = useStore()
const toast = useToast()



const getComments = async () => {
  const payload = {
    community_id: route?.params?.id,
    params: {
      post_id: props?.postId,
      create_by_admin: props?.create_by_admin,
    },
  }
  if (props?.create_by_admin) {
    await store.dispatch(USER_POST_STORE.ACTIONS.SET_LIST_COMMENT_USER_POST, payload)
  } else {
    if (props?.isCSPDetail) {
      await store.dispatch(COMMUNITY_SITE_STORE.ACTIONS.SET_LIST_COMMENT_CSP, payload)
    } else {
      await store.dispatch(POST_STORE.ACTIONS.SET_LIST_COMMENT, payload)
    }
  }
}

const deleteComment = async (): Promise<void> => {
  let params = {
    postId: props.postId,
    postCommentId: props.postCommentId,
    params: {
      create_by_admin: props.create_by_admin,
      comment_published_flg: props.commentPublishedFlg,
    },
  }
  var delete_action
  if (props?.isCSPDetail) {
    delete_action = await store.dispatch(COMMUNITY_SITE_STORE.ACTIONS.DELETE_COMMENT_CSP, params)
  } else {
    delete_action = await store.dispatch(POST_STORE.ACTIONS.DELETE_COMMENT, params)
  }
  const isDelete = delete_action
  if (!isDelete?.success) {
    await getComments()
    if (isDelete?.message_code === POST_COMMUNITY_SITE_NOT_FOUND) {
      toast.error({
        component: communitySitePostDeleted,
      })
    }
  }
  if (isDelete?.success) {
    emit('showDeleteCommentSuccessModal', isDelete)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('deleteCommentTitle')), 1),
          _hoisted_6
        ]),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(translate)('deleteCommentModalContent')), 1),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(Button, {
            title: _unref(translate)('cancel'),
            type: "secondary",
            "data-bs-dismiss": "modal",
            class: "me-2"
          }, null, 8, ["title"]),
          _createVNode(Button, {
            title: "削除する",
            onClick: __props.handleDeleteClick ?? deleteComment,
            type: "secondary",
            "data-bs-dismiss": "modal"
          }, null, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}
}

})